import { useRouter } from "next/navigation";
import React from "react";
import { Divider } from "staysure-component-library";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import useGtmCustomEvent from "@/hooks/gtm/use-gtm-custom-events";
import { useRenewalStateContext } from "@/providers/renewal-state-provider";

type ContactDetailsType = {
  telephoneEditButtonLabel: string;
  email: string;
  mobile: string;
};

function ContactDetails({
  telephoneEditButtonLabel,
  email,
  mobile,
}: Readonly<ContactDetailsType>) {
  const router = useRouter();
  const { updateLastEditAccordion } = useRenewalStateContext();

  const handleGtmEvent = useGtmCustomEvent({
    event: "custom_events",
    eventName: "edit_cta",
    quoteSection: "contact details",
  });

  const { current } = useWizard();

  return (
    <div className="flex flex-col" id="contact-details-wrapper">
      <div className="flex justify-between items-start">
        <div>
          <p className="font-body-font text-xs font-[700] leading-[27px] text-interactive-secondary-default">
            {email || ""}
          </p>
        </div>
      </div>
      <Divider margin={12} color="#DCDCDC" />
      <div className="flex justify-between items-start">
        <div>
          <p className="font-body-font text-xs font-[700] leading-[27px] text-interactive-secondary-default">
            {mobile || ""}
          </p>
        </div>
        <div>
          <LabelButtonWrapper
            id="contact-details-edit-button"
            label={telephoneEditButtonLabel}
            hierarchy="tertiary"
            className="font-body-font leading-[18px] font-[600] text-xs realtive top-[-2px] !px-spacing-xxs"
            onClick={() => {
              updateLastEditAccordion("contact-details");
              handleGtmEvent();
              router.push(
                current?.edges?.contactDetailsEdit ??
                  "/contact-details/contactsEdit=true"
              );
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ContactDetails;
